import type {
  BugsnagLight,
  BreadcrumbType,
  NotifyOptions,
} from '@shopify/bugsnag-light-core';
import {createContext} from 'preact';

export const BugsnagContext = createContext({
  notify: (_error: Error, _options?: NotifyOptions) => {},
  leaveBreadcrumb: (_name: string, _metaData: any, _type: BreadcrumbType) => {},
  client: undefined as BugsnagLight | undefined,
});
